import { render } from "./Configuracion.vue?vue&type=template&id=19a56bfe&scoped=true"
import script from "./Configuracion.vue?vue&type=script&lang=js"
export * from "./Configuracion.vue?vue&type=script&lang=js"

import "./Configuracion.vue?vue&type=style&index=0&id=19a56bfe&scoped=true&lang=css"

import exportComponent from "C:\\wServer\\app-pagos-elroble\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a56bfe"]])

export default __exports__